// eslint-disable-next-line import/prefer-default-export
export enum ViewMode {
  ActiveEmployees = 'activeEmployees',
  InactiveEmployees = 'inactiveEmployees',
  DeletedScorecards = 'deletedScorecards',
  Profiles = 'profiles',
}
